<app-rich-text-viewer [title]="data?.title" [editor]="data?.editor" [content]="data?.content" [files]="getFiles()" [view]="data?.viewCount"
    [date]="data?.updatedAt" [gallery]="true" (edit)="edit($event)" (delete)="requestDeletePost($event)" (download)="downloadFile($event)">
</app-rich-text-viewer>